export default __webpack_public_path__ + "static/media/portfolio.720e6cc9.jpg";